import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { AutoGrowTextarea } from '@/components/ui/autoGrowTextarea';
import { Card } from '@/components/ui/card';

const NOTES_TEXTAREA_CLASS_NAME =
  'mt-1 w-full rounded-xl border border-zooborder bg-zoowhite px-3 py-2 text-sm text-zooindigo';

interface FirstConsultationNotesCardsProps {
  sharedNotes: string;
  privateNotes: string;
  isDisabled: boolean;
  onSharedNotesChange: (value: string) => void;
  onPrivateNotesChange: (value: string) => void;
}

export function FirstConsultationNotesCards({
  sharedNotes,
  privateNotes,
  isDisabled,
  onSharedNotesChange,
  onPrivateNotesChange,
}: FirstConsultationNotesCardsProps) {
  const { t } = useTranslation('consultations');

  return (
    <>
      <Card>
        <label className="block text-xs font-semibold text-zoomuted">
          <span className="block text-sm font-bold text-zooindigo">{t('editor.sharedNotes')}</span>
          <span className="block font-normal mt-0.5">{t('editor.sharedNotesHint')}</span>
          <AutoGrowTextarea
            value={sharedNotes}
            disabled={isDisabled}
            rows={4}
            placeholder={t('editor.sharedNotesPlaceholder')}
            onChange={function changeSharedNotes(event) {
              onSharedNotesChange(event.target.value);
            }}
            className={NOTES_TEXTAREA_CLASS_NAME}
          />
        </label>
      </Card>

      <Card>
        <label className="block text-xs font-semibold text-zoomuted">
          <span className="flex items-center gap-1.5 text-sm font-bold text-zooindigo">
            <Icon name="Lock" />
            {t('editor.privateNotes')}
          </span>
          <span className="block font-normal mt-0.5">{t('editor.privateNotesHint')}</span>
          <AutoGrowTextarea
            value={privateNotes}
            disabled={isDisabled}
            rows={3}
            placeholder={t('editor.privateNotesPlaceholder')}
            onChange={function changePrivateNotes(event) {
              onPrivateNotesChange(event.target.value);
            }}
            className={NOTES_TEXTAREA_CLASS_NAME}
          />
        </label>
      </Card>
    </>
  );
}
